module.exports = __webpack_public_path__ + "media/images/categories/headers/management-91c1b7a2e6d7b18afe363fed5fd2d56e.jpg";